import * as types from '../actiontypes';
import Env from '../../util/env';
import {serviceURL, promiseAreas} from '../../util/uiconstants';

export function getAllProjects(url) {
	return {
		type: types.GET_ALL_PROJECTS,
		meta: {
			api: {
				url: url,
				method: 'GET',
				trackWithArea: promiseAreas.USER_PROJECTS_AREA
			}
		}
	};
}

export function getAllOtherProjects(url) {
	return {
		type: types.GET_ALL_OTHER_PROJECTS,
		meta: {
			api: {
				url: url,
				method: 'GET',
				trackWithArea: promiseAreas.OTHER_PROJECTS_AREA
			}
		}
	};
}

export function getProjectDetails(
	projectId,
	queryString,
	payload,
	promiseArea = promiseAreas.GET_PROJECT_DETAILS_AREA
) {
	const url = `${Env.getBaseURL(serviceURL)}Projects/${projectId}${queryString ? queryString : ''}`;
	return {
		type: types.GET_PROJECT_DETAILS,
		meta: {
			api: {
				url: url,
				method: 'GET',
				trackWithArea: promiseArea
			}
		},
		payload
	};
}

export function cleanProjectDetails() {
	return {
		type: types.CLEAN_PROJECT_DETAILS
	};
}

export function clearAllProjects() {
	return {
		type: types.CLEAR_ALL_PROJECTS
	};
}

export function getProjectEntities(url) {
	return {
		type: types.GET_PROJECT_ENTITIES,
		meta: {
			api: {
				url: url,
				method: 'GET',
				trackWithArea: promiseAreas.GET_PROJECT_ENTITIES_AREA
			}
		}
	};
}

export function removeProject(projectId) {
	const url = `${Env.getBaseURL(serviceURL)}Projects/${projectId}/users/Me`;
	return {
		type: types.REMOVE_PROJECT,
		projectId,
		meta: {
			api: {
				url: url,
				method: 'DELETE'
			}
		}
	};
}

export function markCompleteProject(url, payload) {
	return {
		type: types.MARK_COMPLETE_PROJECT,
		meta: {
			api: {
				url: url,
				method: 'PATCH',
				data: payload.body
			}
		}
	};
}

export function setRollForwardMode(isRollForwardMode) {
	return {
		type: types.SET_ROLL_FORWAD_MODE,
		isRollForwardMode
	};
}

export function getProjectToRollForward(projectId, clientsToRollForward) {
	const url = `${Env.getBaseURL(serviceURL)}Projects/${projectId}?IncludeContactsDetails=${true}`;
	return {
		type: types.GET_PROJECT_TO_ROLL_FORWARD,
		meta: {
			api: {
				url: url,
				method: 'GET',
				trackWithArea: promiseAreas.GET_PROJECT_DETAILS_AREA
			}
		},
		payload: {clientsToRollForward}
	};
}

export function setOversightActiveTab(tab) {
	return {
		type: types.SET_OVERSIGHT_ACTIVE_TAB,
		tab
	};
}

export function getPermissions(projectId) {
	const url = `${Env.getBaseURL(serviceURL)}Projects/${projectId}/Users/Me`;
	return {
		type: types.GET_PERMISSIONS,
		meta: {
			api: {
				url: url,
				method: 'GET',
				trackWithArea: promiseAreas.ENGAGEMENT_METRICS_AREA
			}
		}
	};
}

export function deleteProject(projectId) {
	const url = `${Env.getBaseURL(serviceURL)}Projects/${projectId}`;
	return {
		type: types.DELETE_PROJECT,
		projectId,
		meta: {
			api: {
				url: url,
				method: 'DELETE'
			}
		}
	};
}

export function updateProjectStatus(url, payload) {
	return {
		type: types.UPDATE_PROJECT_STATUS,
		meta: {
			api: {
				url: url,
				method: 'PUT',
				data: payload.body,
				trackWithArea: promiseAreas.GET_PROJECT_DETAILS_AREA
			}
		}
	};
}

export function updateProjectCustomColumns(projectId, customColumns) {
	const url = `${Env.getBaseURL(serviceURL)}Projects/${projectId}/CustomColumns`;
	return {
		type: types.UPDATE_PROJECT_CUSTOM_COLUMNS,
		meta: {
			api: {
				url: url,
				method: 'PUT',
				data: customColumns
			}
		},
		projectId
	};
}

export const updateEntities = (projectId, data, entity) => {
	const url = `${Env.getBaseURL(serviceURL)}Projects/${projectId}`;

	return {
		type: types.UPDATE_ENTITY,
		meta: {
			api: {
				url: url,
				method: 'PUT',
				data
			},
			entity
		}
	};
};
